export enum EBlockShapeDividerFlip {
    NONE = 'none',
    HORIZONTAL = 'horizontal',
    VERTICAL = 'vertical',
}
